// 返回 CSS inset 所需的上、右、下、左裁剪像素。
function tileClipInsets(coords, size, northWest, southEast) {
  const x = coords.x * size
  const y = coords.y * size
  const clamp = value => Math.max(0, Math.min(size, value))
  return [
    clamp(northWest.y - y),
    clamp(x + size - southEast.x),
    clamp(y + size - southEast.y),
    clamp(northWest.x - x)
  ]
}

module.exports = { tileClipInsets }
